<template>
  <BlBackdrop
    title="Customize prompt visibility"
    label="Save"
    description="Select the prompts that are visible during the session."
    :submitLoading="submitLoading"
    @backdrop-close="onCancel"
    @backdrop-action="onSavePrompts"
  >
    <div
      class="grid grid-cols-2 gap-6 px-8 py-4 overflow-y-auto w-200"
      :style="{ maxHeight: 'calc(100vh - 16rem)' }"
    >
      <div>
        <div
          v-for="prompt in defaultPrompts"
          :key="prompt.key"
          :class="[
            prompt.name === successMetric
              ? 'cursor-not-allowed'
              : 'cursor-pointer'
          ]"
        >
          <div
            class="flex items-center h-10 gap-2 truncate"
            :class="{ 'pointer-events-none': prompt.name === successMetric }"
            @click.prevent="toggleEnabled(prompt)"
          >
            <BlInputToggle
              :disabled="prompt.name === successMetric"
              :checked="prompt.enabled"
              class="flex-shrink-0"
              :class="{ 'opacity-50': prompt.enabled }"
              @changed="toggleEnabled(prompt)"
            />
            <div class="flex truncate">
              <BlTextBody2
                :text="prompt.name"
                :title="prompt.name"
                class="truncate"
              />
            </div>
            <BlIcon
              v-if="prompt.shape && prompt.color"
              class="w-5"
              :icon="'prompt-' + prompt.shape"
              :color="prompt.color"
            />
            <BlTextBody2
              v-if="prompt.name === successMetric"
              text="as success metric"
              class="text-xs italic"
            />
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-center p-4 border rounded bg-grey-100 border-grey-200"
        :style="
          defaultPrompts.length > 8
            ? { height: defaultPrompts.length * 2.5 + 'rem' }
            : { height: '20rem' }
        "
      >
        <PromptPreview
          :prompts="defaultPrompts.filter(i => i.enabled)"
          :style="{ transform: 'scale(0.5 , 0.5)' }"
        />
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import draggable from "vuedraggable";

import PromptPreview from "@/components/repository/prompting/Preview.vue";
import PromptItem from "@/components/repository/prompting/Item.vue";

import BlBackdrop from "../../BlBackdrop.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlIcon from "../../BlIcon.vue";
import BlInputToggle from "../../BlInputToggle.vue";

export default {
  name: "CustomizePromptModal",
  components: {
    draggable,
    PromptPreview,
    PromptItem,
    BlBackdrop,
    BlInputButton,
    BlTextBody2,
    BlIcon,
    BlInputToggle
  },
  props: ["measurementId", "prompts", "successMetric"],
  data() {
    return {
      submitLoading: false,
      defaultPrompts: []
    };
  },
  computed: {
    ...mapGetters(["session"])
  },
  watch: {
    prompts(val) {
      this.generateDefaultPrompts(val);
    }
  },
  mounted() {
    this.generateDefaultPrompts(this.prompts);
  },
  methods: {
    ...mapActions(["getMeasurements", "updateMeasurementResults"]),
    generateDefaultPrompts(val) {
      if (val) {
        const keys = Object.keys(val);
        if (keys && keys.length) {
          const n = keys
            .map(i => ({ ...val[i], key: i }))
            .sort((a, b) => a.position - b.position);
          this.defaultPrompts = n;
        }
      }
    },
    isUsedToSuccessMetric(promptName) {
      return promptName === this.successMetric;
    },
    toggleEnabled(item) {
      const index = this.defaultPrompts.findIndex(
        i => Number(i.key) === Number(item.key)
      );
      if (index > -1) {
        this.defaultPrompts[index].enabled = !item.enabled;
      }
    },
    async onSavePrompts() {
      this.submitLoading = true;
      const data = {
        id: this.measurementId,
        results: {}
      };
      this.defaultPrompts.forEach(i => {
        data.results[i.key] = i;
      });
      await this.updateMeasurementResults(data);
      this.submitLoading = false;
      this.$emit("close-modal");
    },
    async onCancel() {
      this.submitLoading = true;
      this.getMeasurements({ id: this.session.id });
      this.submitLoading = false;
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sessions/modal/CustomizePromptModal.vue